<template>
  <list listTitle="Produtos aguardando match" :listLogo="moduleDefinition.logo" filterTitle="Listagem de produtos" :loading="loading" :total="total" :sortFields="['title']" :sortDefault="{ field: 'title', order: 'asc' }" @change="onChange" v-on:loadMore="loadMore">
    <div slot="top-actions"></div>
    <template slot="filters">
      <form-group label="Código do produto">
        <input class="form-input" v-model="options.code">
      </form-group>
      <form-group label="EAN do produto">
        <input class="form-input" v-model="options.ean">
      </form-group>
      <form-group label="Título do produto">
        <input class="form-input" v-model="options.title">
      </form-group>
      <form-group label="Marca">
        <select v-model="options.brand" class="form-select">
          <option value="">Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>
    </template>
    <div class="l-col-12@md" v-if="products.length" v-for="product in products" :key="product">
      <product-match-card :product="product" v-if="product.status === 'match'"/>
    </div>
    <div class="l-col u-textCenter" v-else>
      <panel>Nenhum produto encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { merge } from 'lodash'
  import api from '@/api'
  import List from '@/components/shared/list/Scroll'
  import FormGroup from '@/components/template/FormGroup'
  import ProductMatchCard from '@/components/ProductMatch/Card'

  export default {
    data: () => ({
      module: {
        type: 'marketplace',
        identifier: 'cnova'
      },
      loading: true,
      total: 0,
      products: [],
      brands: [],
      options: {
        code: '',
        title: '',
        brand: '',
        ean: '',
        status: 'match',
        sortField: 'title',
        sortOrder: 'asc'
      }
    }),
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(result => {
          this.brands = result
        }).catch(() => {
          this.brands = []
        })
    },
    methods: {
      onChange (options) {
        this.loading = true

        merge(this.options, options)

        api.getProductsList(this.module.type, this.module.identifier, this.options).then(result => {
          this.products = result.items
          this.total = result.total
          this.loading = false
        }).catch(() => {
          this.total = 0
          this.products = []
          this.loading = false
        })
      },
      async loadMore (options) {
        merge(this.options, options)

        api.getProductsList(this.module.type, this.module.identifier, this.options).then(result => {
          for (let i in result.items) {
            this.products.push(result.items[i])
          }

          this.total = result.total
          this.loading = false
          options.fetchingMore = false
        }).catch(() => {
          this.loading = false
          options.finished = true
          options.fetchingMore = false
        })
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.module.type, this.module.identifier)
      }
    },
    components: {
      List,
      FormGroup,
      ProductMatchCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?31fc2a7b